export default {
  bind(el) {
    if (el.type !== "email") return;

    el.addEventListener("blur", () => {
      const raw = el.value;
      if (!raw) return;

      const value = raw
        .normalize("NFKC")
        .replace(/。/g, ".")
        .replace(/、/g, ",")
        .replace(/ー/g, "-")
        .replace(/．/g, ".")
        .trim();

      if (value === raw) return;

      el.value = value;

      // Update Vue 2's v-model
      el.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }
};